import React, {useState} from "react";
import { useNavigate } from "react-router";
import '../CSS/login.css';
import Rosmo from '../Img/New-Rosmo-Blue.jpg'
import Logo from "../Img/New-Rosmo-White.png"
//import Logo from "../Img/rosmo-white.jpeg"
import Swal from "sweetalert2";
//import Load from '../Img/load-ing.gif'
import { Modal } from 'react-bootstrap';
import { loginApi } from "../Conexiones/Models";
//import { PropagateLoader } from "react-spinners";

function Login() {
    sessionStorage.setItem('user', null);
    //console.clear();
    const [usuario, setUsuario] = useState();
    const [pass, setPass] = useState();
    const navigate = useNavigate()

    //MODAL DESCARGANDO
    const [showLoading, setShowLoading] = useState(false);
    const handleCloseLoading = () => {
        setShowLoading(false);
    }
    const handleShowLoading = () =>{
        setShowLoading(true);
    }

    const handleSubmit = async e => {
        handleShowLoading();
        e.preventDefault();
        /*await Swal.fire({
            background: '#001d30',
            html: `<div><div class="spinner-border" style="width: 3rem; height: 3rem; color:white;" role="status">
            <span class="visually-hidden">Loading...</span>
          </div><br><br><div style="color:white;">ESPERE UN MOMENTO...</div></div>`,
            width:600,
            showConfirmButton: false,
            timer: 4000,
            allowOutsideClick: false,
        })*/
        const endpoint = 'login/';
        const data = {email:usuario,password:pass};
        const res = await loginApi(endpoint,data);
        handleCloseLoading();
        if(res.status === 1){
            if(res.data.message==="CONEXION EXITOSA"){
                sessionStorage.setItem('user', JSON.stringify([res.data.datos[0]]));
                navigate('/inicio');
            }else{
                const Toast = Swal.mixin({
                    toast: true,
                    position: "center",
                    background:"#f50400",
                    showConfirmButton: false,
                    timer: 5000,
                    timerProgressBar: false,
                    showCloseButton:true,
                    didOpen: (toast) => {
                      toast.onmouseenter = Swal.stopTimer;
                      toast.onmouseleave = Swal.resumeTimer;
                    }
                });
                Toast.fire({
                    icon: "error",
                    iconColor:"#FFFFFF",
                    color:"#FFFFFF",
                    title: '¡ERROR!',
                    text: res.data.message,
                });
            }
        }else{
            handleCloseLoading();
            const Toast = Swal.mixin({
                toast: true,
                position: "center",
                background:"#f50400",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: false,
                showCloseButton:true,
                didOpen: (toast) => {
                  toast.onmouseenter = Swal.stopTimer;
                  toast.onmouseleave = Swal.resumeTimer;
                }
            });
            Toast.fire({
                icon: "error",
                iconColor:"#FFFFFF",
                color:"#FFFFFF",
                title: '¡ERROR!',
                text: res.message,
            });
        }
    }
    return (
        <div className="contenedor">
            <div className="elemento">
                <div className="row d-flex justify-content-center align-items-center" >
                    <div className="col col-xl-10" >
                        <div className="card card-login" >
                            <div className="row  g-3" >
                                <div className="col-md-6 col-lg-5 left-form" >
                                    <img src={Rosmo} alt="Rosmo-img" className="img-fluid img-login"/>
                                    <div className="texto">SantiagoM | GreciaA | Todos los derechos reservados</div>
                                </div>
                                <div className="col-md-6  col-lg-7 d-flex right-form" >
                                    <div className="card-body p-lg-0 card-bd" >
                                        <center> <img src={Logo} alt="Rosmo-logo" className="logo-login"/></center>
                                        <h2 className="h2">BIENVENIDO</h2>
                                        <form  onSubmit={handleSubmit} >                                        
                                            <div className="form-outline mb-3" >
                                                <center><input type="email" className="form-control form-control-md input-form input-boxes" style={{color:'#1e2c4f'}} placeholder="USUARIO" 
                                                onChange={e => setUsuario(e.target.value)} autoComplete='off' required/></center>
                                            </div>
                                            <div className="form-outline mb-3">
                                                <center><input type="password" className="form-control form-control-md input-form input-boxes" style={{color:'#1e2c4f'}} minLength={6} placeholder="CONTRASEÑA" 
                                                onChange={e => setPass(e.target.value)} autoComplete='off' required/></center>
                                            </div>
                                            <div className=" mb-3 ">
                                                <center>
                                                    <button type="submit" className="btn btn-md form-control button-form">
                                                    {/*<button type="submit" className="btn-login">*/}
                                                        INICIAR SESIÓN
                                                    </button>
                                                </center>  
                                            </div>                           
                                        </form>
                                        {/*<a className="link-password" href={window.location.href+"forgot-password/"}>¿Olvidaste tu contraseña?</a>*/}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*LOADING....*/}
            <Modal  show={showLoading}  onHide={handleCloseLoading} centered  >
                <Modal.Body  style={{textAlign:'center',backgroundColor:"#001d30"}}>
                    <div><div className="spinner-border" style={{width:"3rem",height:"3rem",color:"white"}} role="status">
                        <span className="visually-hidden">Loading...</span>
                    </div><br/><br/><div style={{color:"white"}}>ESPERE UN MOMENTO...</div></div>
                </Modal.Body>
            </Modal>
        </div>
    );
}

export default Login;
